import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Result } from "@arco-design/web-react";
import { FetchApi } from "../Api/AuthenticatedApi";

// Shows the app's pages, unless a platform admin has disabled the active
// organization: then a notice in their place. (The API refuses that org's
// requests anyway; this says why.) The org switcher in the top bar still
// works, for people who belong to another organization.
export default function DisabledAccountGate({ children }) {
  const { getAccessTokenSilently } = useAuth0();
  const [disabled, setDisabled] = useState(false);
  const [otherOrgs, setOtherOrgs] = useState(false);

  useEffect(() => {
    FetchApi(getAccessTokenSilently, "/api/me",
      (data) => {
        setDisabled(!!(data && data.active_organization_disabled));
        setOtherOrgs(((data && data.organizations) || []).length > 1);
      },
      () => {}, () => {});
  }, [getAccessTokenSilently]);

  if (!disabled) return children;
  return (
    <div style={{ padding: "64px 16px" }}>
      <Result
        status="warning"
        title="This account has been disabled"
        subTitle={
          "Please contact support if you think this is a mistake." +
          (otherOrgs ? " You can switch to another organization from your menu at the top right." : "")
        }
      />
    </div>
  );
}
